module.exports = __webpack_public_path__ + "img/fma_2.4aba9433.gif";